module.exports = __webpack_public_path__ + "static/img/pic_22.7c8a394.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pic_22.png
// module id = 3mgD
// module chunks = 1